import { useBillingQueryContext } from 'modules/dataWarehouse/contexts/BillingQueryContext';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const RESTRICT_CREATE_MODAL_TEXT = {
  body: 'You’ve reached the maximum number of syncs allowed within your organization under your current plan (5). To discuss adding more syncs, contact your customer success manager.',
  cancelLabel: 'Close',
  testId: 'restrict-create-modal',
  title: 'Sync limit reached',
};
const { body, cancelLabel, testId, title } = RESTRICT_CREATE_MODAL_TEXT;

type RestrictCreateModalProps = {
  onClose: () => void;
};

export const RestrictCreateModal = ({ onClose }: RestrictCreateModalProps) => {
  const {
    hightouchOrg: {
      organization: { allotment = 5 } = {},
    } = {},
  } = useBillingQueryContext();
  const bodyText = body.replace('5', `${allotment}`);

  return (
    <Modal id={testId} isModalOpen onClose={onClose} size={MODAL_SIZES.SMALL}>
      <ModalHeader variant={MODAL_VARIANTS.WARNING}>
        <span>{title}</span>
      </ModalHeader>
      <ModalBody>{bodyText}</ModalBody>
      <ModalFooter cancelLabel={cancelLabel} />
    </Modal>
  );
};
